import { UserSliceState } from 'src/core/models'

const userState: UserSliceState = {
  user: null,
  errorMessage: '',
  loading: false,
  widgetUsers: [],
  registerForm: {
    step: 0,
    credentials: {
      email: '',
      phone: '',
      password: '',
      confirmPassword: ''
    },
    personalData: {
      firstName: '',
      lastName: '',
      companyName: '',
      country: null
    }
  },
  registerUser: {
    loading: false,
    success: false,
    error: null,
    email: null
  },
  validateEmail: {
    loading: false,
    success: false,
    error: null
  },
  validateEmailForStockSale: {
    loading: false,
    success: false,
    error: null
  },
  changePassword: {
    loading: false,
    success: false,
    errorMessage: null
  },
  updatePersonalData: {
    loading: false,
    success: false,
    error: null,
    newEmail: false
  },
  deleteAuthUser: {
    loading: false,
    success: false,
    errorMessage: null
  },
  userSubscriptions: []
}


export { userState as initialState }
